import ReactPlayer from "react-player";
import THEME from "../../config/theme";
import { useCustomTheme } from '../../contexts/useCustomTheme';
import FullscreenButton from './FullscreenButton';

const VideoPlayer = ({ video, previewVideo, url }) => {
  const src =
    video?.videoInfo?.url ||
    video?.pandaVideoMetadata?.video_player ||
    video?.link ||
    previewVideo ||
    video?.liveStreamURLWeb ||
    url ||
    "";

  const { customColor } = useCustomTheme();

  if (src.search(/youtube|youtu.be/) >= 0 || src.search(/firebasestorage.googleapis/) >= 0 || src.search(/vimeo/) >= 0) {
    return (
      <ReactPlayer
        url={src}
        playing={false}
        width={"100%"}
        controls={true}
        height={"100%"}
        config={{
          youtube: {
            playerVars: {
              origin: window.location.origin,
              rel: 0, // Desativa vídeos relacionados
              modestbranding: 1, // Minimiza a marca do YouTube
              iv_load_policy: 3, // Desativa anotações
              enablejsapi: 1, // Habilita a API JavaScript
              disablekb: 1 // Desativa o teclado
            },
          },
          vimeo: {
            title: video?.title,
            playerOptions: { origin: window.location.origin },
          },
          file: {
            attributes: {
              controlsList: "nodownload",
            },
          },
        }}
      />
    );
  } else if (src) {
    return (
      <FullscreenButton>
        <iframe
          id="panda-1"
          src={`${src}&color=${customColor && customColor.primary ? customColor.primary.substring(1) : THEME.COLORS.PRIMARY_900.substring(1)}`}
          style={{ border: 'none', position: 'absolute', zIndex: 1 }}
          allowFullScreen={true}
          width="100%"
          height="100%"
          allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;camera;microphone;payment"
          referrerPolicy="strict-origin-when-cross-origin"
          sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox allow-presentation"
        ></iframe>
      </FullscreenButton>
    );
  }
};

export default VideoPlayer;
